import React from 'react';
import './Radio.css';

const Radio = ({ checked, onChange, label, name, value, className = '', ...props }) => {
  return (
    <label className={`radio-container ${className}`}>
      <input
        type="radio"
        checked={checked}
        onChange={onChange}
        name={name}
        value={value}
        className="radio-input"
        {...props}
      />
      <span className="radio-custom"></span>
      {label && <span className="radio-label">{label}</span>}
    </label>
  );
};

export default Radio; 